/* STH Apparel Builder: "your art on this shirt" preview for printed tees and hoodies (DTF).
   Plain JS, no libraries. Needs customizer.js first (it shares the upload / background helpers).
   Mount with STHApparel.mount(rootEl, config). Like the hat builder it knows nothing about
   Shopify: the page passes the garment profile, a variantFor(layout, sizeGroup) lookup and an
   onAddToCart handler. Each print spot has a fixed largest size; that's what the customer pays for. */
(function () {
  'use strict';

  const U = window.STHCustomizer && window.STHCustomizer.util;
  if (!U) { console.error('STHApparel needs sth-customizer.js loaded first'); return; }
  const { clamp, esc, makeCanvas, loadImage, artToCanvas, removeBackground, trim, sampleArt, PREVIEWABLE } = U;

  // Order totals run into the thousands, so group the digits ($1,320.22).
  const money = (n) => '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const lum = (hex) => {
    const h = hex.replace('#', ''), c = [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16) / 255);
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  };

  // Share of the art's visible pixels that are close in colour to the garment, to warn about
  // black art on a black shirt. Colour distance, not brightness: red on forest green is fine.
  function blendsIn(art, hex) {
    const n = 48, c = makeCanvas(n, n), x = c.getContext('2d');
    x.drawImage(art, 0, 0, n, n);
    const d = x.getImageData(0, 0, n, n).data, h = hex.replace('#', '');
    const g = [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
    let near = 0, seen = 0;
    for (let i = 0; i < d.length; i += 4) {
      if (d[i + 3] < 128) continue;
      seen++;
      if (Math.hypot(d[i] - g[0], d[i + 1] - g[1], d[i + 2] - g[2]) < 70) near++;
    }
    return seen ? near / seen : 0;
  }

  // The garment's own folds and shadows under the print, as a grey map centred on mid-grey.
  // Soft-lit onto the print it makes the ink sit in the fabric instead of floating on top.
  function shadeMap(photo, sx, sy, sw, sh, w, h) {
    const c = makeCanvas(w, h), x = c.getContext('2d');
    x.drawImage(photo, sx, sy, sw, sh, 0, 0, w, h);
    const id = x.getImageData(0, 0, c.width, c.height), d = id.data;
    let m = 0;
    for (let i = 0; i < d.length; i += 4) m += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2];
    m /= d.length / 4;
    for (let i = 0; i < d.length; i += 4) {
      const l = 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2];
      const v = clamp(128 + (l - m) * 1.6, 0, 255);
      d[i] = d[i + 1] = d[i + 2] = v;
    }
    x.putImageData(id, 0, 0);
    return c;
  }

  function mount(root, cfg) {
    const P = cfg.product;
    if (!P.colors || !P.colors.length) {
      root.innerHTML = `<p class="sthc-fallback">The preview isn't available right now. <a href="/pages/custom-quote">Request a quote</a> and we'll send a free mockup.</p>`;
      return null;
    }
    const side = () => ({ raw: null, art: null, file: null, fileName: '', previewable: true, upload: null, bgRemoved: false });
    // Placement is per side even when both sides share the art: the back print is bigger.
    const spot0 = () => ({ wIn: null, dx: 0, dy: 0 });
    const S = {
      colorIdx: 0,
      view: 'front',
      front: P.spots.front[0].id,   // left chest by default: the most common order
      back: null,
      sides: { front: side(), back: side(), sleeve: side() },
      place: { front: spot0(), back: spot0() },
      sameArt: true,
      sleeve: null,       // add-on: null | 'left' | 'right' (the wearer's sleeve)
      sleeveOpt: P.sleeve ? P.sleeve.options[0].id : null,
      sleeveSame: true,   // reuse the main art on the sleeve
      removeBg: true,
      holes: true,        // clear enclosed backdrop (letter counters) too
      emailLater: false,
      sizes: {},
      photos: {},
      sample: sampleArt('YOUR', 'LOGO HERE'),
    };
    P.sizes.forEach((s) => { S.sizes[s] = 0; });

    const spotOf = (v) => (S[v] ? P.spots[v].find((s) => s.id === S[v]) : null);
    const layoutName = () => [spotOf('front'), spotOf('back')].filter(Boolean).map((s) => s.name).join(' + ');
    // The back can reuse the front art (the usual "logo on both sides" order).
    const artSide = (v) => (v === 'back' && S.sameArt && S.front ? S.sides.front : S.sides[v]);
    // Placeholder art in white on dark garments so it shows up.
    const tinted = {};
    function placeholder(kind) {
      const light = lum(P.colors[S.colorIdx].hex) < 0.45, key = kind + light;
      if (!tinted[key]) {
        const src = kind === 'proof' ? sampleArt('PROOF', 'TO FOLLOW') : S.sample;
        const c = makeCanvas(src.width, src.height), x = c.getContext('2d');
        x.drawImage(src, 0, 0);
        if (light) { x.globalCompositeOperation = 'source-in'; x.fillStyle = '#fff'; x.fillRect(0, 0, c.width, c.height); }
        tinted[key] = c;
      }
      return tinted[key];
    }
    const artFor = (v) => artSide(v).art || placeholder(artSide(v).file && !artSide(v).previewable ? 'proof' : 'sample');
    // Sleeve add-on: its own upload, or the front art (else the back art) when "same art" is ticked.
    const sleeveOpt = () => (P.sleeve ? P.sleeve.options.find((o) => o.id === S.sleeveOpt) || P.sleeve.options[0] : null);
    const sleeveSide = () => (S.sleeveSame && (S.front || S.back) ? artSide(S.front ? 'front' : 'back') : S.sides.sleeve);
    const sleeveArt = () => sleeveSide().art || placeholder(sleeveSide().file && !sleeveSide().previewable ? 'proof' : 'sample');

    root.classList.add('sthc', 'stha');
    root.innerHTML = `
      <div class="sthc-stage">
        <div class="stha-views" role="tablist">
          <button type="button" class="sthc-chip" data-view="front">Front</button>
          <button type="button" class="sthc-chip" data-view="back">Back</button>
        </div>
        <div class="sthc-canvas-wrap">
          <canvas class="sthc-canvas stha-canvas" width="1000" height="1250" aria-label="Garment preview"></canvas>
          <div class="sthc-loading" hidden>Loading…</div>
          <p class="sthc-pill">Drag your art to move it · scroll or pinch to resize</p>
        </div>
        <div class="sthc-stage-actions">
          <button type="button" class="sthc-link" data-download>Download mockup</button>
          <button type="button" class="sthc-link" data-reset>Reset placement</button>
        </div>
      </div>
      <div class="sthc-panel">
        <div class="sthc-group">
          <p class="sthc-label">Color <span data-color-name></span></p>
          <div class="sthc-swatches" data-colors></div>
        </div>
        <div class="sthc-group">
          <p class="sthc-label">Front print</p>
          <div class="sthc-chips" data-spots="front"></div>
        </div>
        <div class="sthc-group">
          <p class="sthc-label">Back print</p>
          <div class="sthc-chips" data-spots="back"></div>
        </div>
        <div class="sthc-group" data-sleeve-group hidden>
          <p class="sthc-label">Sleeve print <span data-sleeve-price></span></p>
          <div class="sthc-chips" data-sleeves></div>
          <div class="sthc-chips stha-sleeve-opts" data-sleeve-opts></div>
          <div data-sleeve-art hidden>
            <label class="sthc-check"><input type="checkbox" data-sleeve-same checked> Use the same art as the front</label>
            <div data-sleeve-drop>${dropZone('sleeve')}</div>
            <p class="sthc-note">Shown on the front view. We place it on the sleeve and confirm it on your proof.</p>
          </div>
        </div>
        <div class="sthc-group" data-art-group="front">
          <p class="sthc-label">Front artwork</p>
          ${dropZone('front')}
        </div>
        <div class="sthc-group" data-art-group="back">
          <p class="sthc-label">Back artwork</p>
          <label class="sthc-check" data-same-row><input type="checkbox" data-same checked> Use the same art as the front</label>
          <div data-back-drop>${dropZone('back')}</div>
        </div>
        <div class="sthc-group">
          <label class="sthc-check" data-bg-row hidden><input type="checkbox" data-removebg checked> Remove the background behind my art</label>
          <label class="sthc-check" data-holes-row hidden><input type="checkbox" data-holes checked> <span>Also clear the background color inside letters and shapes<br><small>Untick if parts of your art should print white, like white text inside a badge.</small></span></label>
          <label class="sthc-check"><input type="checkbox" data-later> I'll email my art after ordering</label>
          <p class="sthc-note" data-contrast hidden></p>
        </div>
        <div class="sthc-group">
          <p class="sthc-label">Placement <span data-place-side></span></p>
          <div class="sthc-slider"><span>Size</span><input type="range" data-size min="0.3" max="1" step="0.01"><b data-size-val></b></div>
          <p class="sthc-note" data-size-note></p>
          <div class="sthc-slider"><span>Across</span><input type="range" data-dx step="0.05"><b data-dx-val></b></div>
          <div class="sthc-slider"><span>Up / down</span><input type="range" data-dy step="0.05"><b data-dy-val></b></div>
        </div>
        <div class="sthc-group">
          <p class="sthc-label">Sizes <span data-qty-total></span></p>
          <div class="stha-sizes" data-sizes></div>
          <p class="sthc-note" data-min-note></p>
        </div>
        <div class="sthc-group sthc-buy stha-buy">
          <div class="sthc-price"><strong data-total></strong><small data-each></small></div>
          <p class="sthc-note sthc-full" data-lines></p>
          <p class="sthc-note sthc-full" data-next-break></p>
          <button type="button" class="sthc-btn" data-add>Add to cart</button>
          <p class="sthc-bulk" data-bulk></p>
          <p class="sthc-error" data-error hidden></p>
        </div>
      </div>`;

    function dropZone(v) {
      return `<label class="sthc-drop" data-drop="${v}">
            <input type="file" class="sthc-file" data-file="${v}" accept="${esc(cfg.accept)}">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="M17 8l-5-5-5 5"/><path d="M12 3v12"/></svg>
            <span><strong data-drop-title="${v}">Drop your art here or choose a file</strong>
            <small>PNG with a clear background works best. JPG, SVG, PDF, AI and EPS are fine too.</small></span>
          </label>
          <p class="sthc-status" data-status="${v}" hidden></p>`;
    }

    const $ = (s) => root.querySelector(s);
    const canvas = $('.stha-canvas'), ctx = canvas.getContext('2d');

    $('[data-colors]').innerHTML = P.colors.map((c, i) =>
      `<button type="button" class="sthc-swatch" data-color="${i}" title="${esc(c.name)}" aria-label="${esc(c.name)}" style="background:${c.hex}"></button>`).join('');
    ['front', 'back'].forEach((v) => {
      $(`[data-spots="${v}"]`).innerHTML = `<button type="button" class="sthc-chip" data-spot="${v}:">None</button>` +
        P.spots[v].map((s) => `<button type="button" class="sthc-chip" data-spot="${v}:${s.id}">${esc(s.name)} <small>up to ${s.w}" × ${s.h}"</small></button>`).join('');
    });
    if (P.sleeve) {
      $('[data-sleeve-group]').hidden = false;
      $('[data-sleeves]').innerHTML = [['', 'None'], ['left', 'Left sleeve'], ['right', 'Right sleeve']]
        .map(([id, n]) => `<button type="button" class="sthc-chip" data-sleeve="${id}">${n}</button>`).join('');
      $('[data-sleeve-opts]').innerHTML = P.sleeve.options.length > 1 ? P.sleeve.options.map((o) =>
        `<button type="button" class="sthc-chip" data-sleeve-opt="${o.id}">${esc(o.name)} <small>up to ${o.w}" × ${o.h}" · +${money(o.price)}</small></button>`).join('') : '';
    }
    $('[data-sizes]').innerHTML = P.sizes.map((s) =>
      `<label class="stha-size"><span>${esc(s)}</span><input type="number" min="0" max="999" inputmode="numeric" value="0" data-sz="${esc(s)}" aria-label="How many ${esc(s)}"></label>`).join('');

    const W = 1000, H = 1250;

    /* --- art size and position, in inches --- */

    // Size is capped by the print spot (what the customer pays for). Position is free anywhere in
    // the garment's zone for that side, so a left chest print can go on the right chest or centre.
    // Largest width that fits the spot at the art's proportions.
    function maxW(v) {
      const sp = spotOf(v), a = artFor(v), ar = a.height / a.width;
      return Math.min(sp.w, sp.h / ar);
    }
    function artInches(v) {
      const st = S.place[v], a = artFor(v), m = maxW(v);
      const w = clamp(st.wIn == null ? m : st.wIn, Math.min(1, m), m);
      return { w, h: w * a.height / a.width };
    }
    // Zone for a side in pixels of the 1000 x 1250 photo (older profiles: just the spot's box).
    function zonePx(v) {
      const z = P.zones && P.zones[v];
      if (z) return { x0: z[0] / 100 * W, y0: z[1] / 100 * H, x1: z[2] / 100 * W, y1: z[3] / 100 * H };
      const sp = spotOf(v), cx = sp.x / 100 * W, cy = sp.y / 100 * H, hw = sp.w * P.ppi / 2, hh = sp.h * P.ppi / 2;
      return { x0: cx - hw, y0: cy - hh, x1: cx + hw, y1: cy + hh };
    }
    // Keep the art inside the zone: offsets (inches from the spot's default centre) are limited by
    // the room left around it.
    function clampOffset(v) {
      const st = S.place[v], sp = spotOf(v), a = artInches(v), z = zonePx(v);
      const cx = sp.x / 100 * W, cy = sp.y / 100 * H;
      const lim = (lo, hi, half, c) => {
        let a0 = (lo - c) / P.ppi + half, a1 = (hi - c) / P.ppi - half;
        if (a0 > a1) a0 = a1 = (a0 + a1) / 2;
        return [a0, a1];
      };
      const [x0, x1] = lim(z.x0, z.x1, a.w / 2, cx), [y0, y1] = lim(z.y0, z.y1, a.h / 2, cy);
      st.dx = clamp(st.dx, x0, x1);
      st.dy = clamp(st.dy, y0, y1);
      return { x0, x1, y0, y1 };
    }

    /* --- drawing --- */

    function placed(v, k) {   // pixel box of the art on a canvas k times the photo size
      const sp = spotOf(v); if (!sp) return null;
      clampOffset(v);
      const st = S.place[v], a = artInches(v), ppi = P.ppi * k;
      const bx = sp.x / 100 * W * k, by = sp.y / 100 * H * k;
      const ax = bx + st.dx * ppi, ay = by + st.dy * ppi, z = zonePx(v);
      return {
        x: ax - a.w * ppi / 2, y: ay - a.h * ppi / 2, w: a.w * ppi, h: a.h * ppi,
        max: { x: ax - sp.w * ppi / 2, y: ay - sp.h * ppi / 2, w: sp.w * ppi, h: sp.h * ppi },   // largest print here
        zone: { x: z.x0 * k, y: z.y0 * k, w: (z.x1 - z.x0) * k, h: (z.y1 - z.y0) * k },
      };
    }

    function photo(v) { return S.photos[P.colors[S.colorIdx].id + '-' + v]; }

    function drawScene(target, view, k, guides) {
      const x = target.getContext('2d');
      target.width = W * k; target.height = H * k;
      x.fillStyle = '#fff';
      x.fillRect(0, 0, target.width, target.height);
      const img = photo(view);
      if (!img) return null;
      x.drawImage(img, 0, 0, target.width, target.height);
      if (view === 'front' && S.sleeve && P.sleeve) {
        const o = sleeveOpt(), ppi = P.ppi * k;
        let art = sleeveArt();
        // A wide logo on the long run turns to read down the arm.
        if (o.h > o.w && art.width > art.height) {
          const r = makeCanvas(art.height, art.width), rx = r.getContext('2d');
          rx.translate(r.width / 2, r.height / 2); rx.rotate(Math.PI / 2); rx.drawImage(art, -art.width / 2, -art.height / 2);
          art = r;
        }
        const fit = Math.min(o.w / (art.width / art.height), o.h) / o.h;   // largest that fits the sleeve box
        const ah = o.h * fit, aw = ah * art.width / art.height;
        const cx = P.sleeve.x[S.sleeve] / 100 * W * k, cy = o.y / 100 * H * k;
        printLayer(x, img, art, { x: cx - aw * ppi / 2, y: cy - ah * ppi / 2, w: aw * ppi, h: ah * ppi }, k);
      }
      const b = placed(view, k);
      if (!b) return null;
      if (guides) {
        x.save();
        x.setLineDash([10 * k, 8 * k]);
        x.lineWidth = 2 * k;
        const dark = lum(P.colors[S.colorIdx].hex) < 0.45;
        // Faint: where the print can go. Stronger: the biggest print this spot allows, around the art.
        x.strokeStyle = dark ? 'rgba(255,255,255,.25)' : 'rgba(0,0,0,.15)';
        x.strokeRect(b.zone.x, b.zone.y, b.zone.w, b.zone.h);
        x.strokeStyle = dark ? 'rgba(255,255,255,.55)' : 'rgba(0,0,0,.35)';
        x.strokeRect(b.max.x, b.max.y, b.max.w, b.max.h);
        x.restore();
      }
      printLayer(x, img, artFor(view), b, k);
      return b;
    }

    // Print layer: the art, the fabric's light and shadow soft-lit over it, clipped back to
    // the art (blend modes paint into transparent pixels too).
    function printLayer(x, img, art, b, k) {
      const pw = Math.max(1, Math.round(b.w)), ph = Math.max(1, Math.round(b.h));
      const layer = makeCanvas(pw, ph), lx = layer.getContext('2d');
      lx.drawImage(art, 0, 0, pw, ph);
      const sx = b.x / k * img.naturalWidth / W, sy = b.y / k * img.naturalHeight / H;
      const sw = b.w / k * img.naturalWidth / W, sh = b.h / k * img.naturalHeight / H;
      lx.globalCompositeOperation = 'soft-light';
      lx.globalAlpha = 0.6;
      lx.drawImage(shadeMap(img, sx, sy, sw, sh, pw, ph), 0, 0);
      lx.globalAlpha = 1;
      lx.globalCompositeOperation = 'destination-in';
      lx.drawImage(art, 0, 0, pw, ph);
      x.globalAlpha = 0.96;   // a hair of the fabric shows through, like a real DTF print
      x.drawImage(layer, b.x, b.y);
      x.globalAlpha = 1;
    }

    let lastBox = null, frame = 0;
    function render() {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => { lastBox = drawScene(canvas, S.view, 1, true); });
    }

    async function loadPhotos() {
      const c = P.colors[S.colorIdx];
      const need = ['front', 'back'].filter((v) => !S.photos[c.id + '-' + v]);
      if (!need.length) { render(); return; }
      $('.sthc-loading').hidden = false;
      await Promise.all(need.map(async (v) => {
        const vk = (P.photo.viewKey || {})[v] || v;   // e.g. S&S names its views F / B
        try { S.photos[c.id + '-' + v] = await loadImage(P.photo.url.replace('{id}', c.id).replace('{view}', vk)); }
        catch (e) { showError('Could not load that photo. Try another color.'); }
      }));
      $('.sthc-loading').hidden = true;
      render();
    }

    /* --- pricing --- */

    const groupOf = (size) => (P.groups.includes(size) ? size : P.groups[0]);
    const totalQty = () => P.sizes.reduce((n, s) => n + S.sizes[s], 0);
    // Colours whose blank costs more (camo) price from their own size groups, e.g. "XS–XL · Camo".
    const upcharge = () => (P.colors[S.colorIdx].upcharge ? ' · ' + P.colors[S.colorIdx].upcharge : '');
    function priceFor(group) {
      const g = group + upcharge();
      const v = cfg.variantFor ? cfg.variantFor(layoutName(), g) : null;
      return { price: v ? v.price : (P.prices[layoutName()] || {})[g], variant: v };
    }
    function pricing() {
      const qty = totalQty();
      let pct = 0, tier = 0, next = null;
      for (const b of P.breaks) { if (qty >= b.qty) { pct = b.pct; tier = b.qty; } else if (!next) next = b; }
      const lines = P.groups.map((g) => {
        const sizes = P.sizes.filter((s) => groupOf(s) === g && S.sizes[s] > 0);
        const n = sizes.reduce((m, s) => m + S.sizes[s], 0), p = priceFor(g);
        return { group: g, sizes, qty: n, price: p.price, each: p.price * (1 - pct / 100), variant: p.variant };
      }).filter((l) => l.qty > 0);
      // Sleeve add-on: flat per garment, its own cart line, outside the quantity breaks.
      let sleeve = null;
      if (S.sleeve && P.sleeve) {
        const o = sleeveOpt(), v = cfg.sleeveVariantFor ? cfg.sleeveVariantFor(o.variant) : null;
        sleeve = { opt: o, price: v ? v.price : o.price, variant: v, qty };
      }
      const total = lines.reduce((s, l) => s + l.each * l.qty, 0) + (sleeve ? sleeve.price * qty : 0);
      return { qty, pct, tier, next, lines, sleeve, total, base: priceFor(P.groups[0]).price };
    }

    /* --- sync UI with state --- */

    function syncUI() {
      const c = P.colors[S.colorIdx];
      root.querySelectorAll('[data-color]').forEach((b) => b.classList.toggle('is-on', +b.dataset.color === S.colorIdx));
      $('[data-color-name]').textContent = c.name + (c.upcharge ? ` · ${c.upcharge.toLowerCase()} blanks cost a little more` : '');
      root.querySelectorAll('[data-spot]').forEach((b) => {
        const [v, id] = b.dataset.spot.split(':');
        b.classList.toggle('is-on', (S[v] || '') === id);
      });
      root.querySelectorAll('[data-view]').forEach((b) => {
        b.classList.toggle('is-on', b.dataset.view === S.view);
        b.textContent = (b.dataset.view === 'front' ? 'Front' : 'Back') + (S[b.dataset.view] ? '' : ' (blank)');
      });
      $('[data-art-group="front"]').hidden = !S.front;
      $('[data-art-group="back"]').hidden = !S.back;
      $('[data-same-row]').hidden = !S.front;
      $('[data-back-drop]').hidden = !!(S.front && S.sameArt);
      $('[data-bg-row]').hidden = !(S.sides.front.raw || S.sides.back.raw || S.sides.sleeve.raw);
      $('[data-holes-row]').hidden = !S.removeBg || !['front', 'back', 'sleeve'].some((sd) => S.sides[sd].bgRemoved);
      if (P.sleeve) {
        root.querySelectorAll('[data-sleeve]').forEach((b) => b.classList.toggle('is-on', (S.sleeve || '') === b.dataset.sleeve));
        root.querySelectorAll('[data-sleeve-opt]').forEach((b) => b.classList.toggle('is-on', S.sleeveOpt === b.dataset.sleeveOpt));
        $('[data-sleeve-opts]').hidden = !S.sleeve || P.sleeve.options.length < 2;
        $('[data-sleeve-art]').hidden = !S.sleeve;
        $('[data-sleeve-drop]').hidden = S.sleeveSame && !!(S.front || S.back);
        $('[data-sleeve-price]').textContent = `+${money(sleeveOpt().price)} per ${P.garmentWord || 'piece'}`;
      }

      // Placement controls act on the side being viewed.
      const v = S[S.view] ? S.view : (S.front ? 'front' : 'back');
      const sp = spotOf(v), st = S.place[v], a = artInches(v), room = clampOffset(v);
      $('[data-place-side]').textContent = `${sp.name}`;
      const m = maxW(v);
      $('[data-size]').min = Math.min(1, m) / m; $('[data-size]').value = a.w / m;
      $('[data-size-val]').textContent = `${a.w.toFixed(1)} × ${a.h.toFixed(1)} in`;
      $('[data-size-note]').textContent = `${sp.name} prints up to ${sp.w}" × ${sp.h}" and can sit anywhere on the ${v}. Need bigger? Pick a larger print.`;
      [['dx', room.x0, room.x1], ['dy', room.y0, room.y1]].forEach(([k, lo, hi]) => {
        const el = $(`[data-${k}]`); el.min = lo; el.max = hi; el.value = st[k]; el.disabled = hi - lo < 0.05;
        $(`[data-${k}-val]`).textContent = (st[k] >= 0 ? '+' : '') + st[k].toFixed(1) + '"';
      });

      // Dark art on a dark shirt (or light on light) disappears.
      const con = $('[data-contrast]');
      const own = ['front', 'back'].filter((s) => S[s] && artSide(s).art);
      const close = own.some((s) => blendsIn(artSide(s).art, c.hex) > 0.5);
      con.hidden = !close;
      con.textContent = close ? `Heads up: your art is close to ${c.name}, so it may not stand out. We'll check it on your proof, or try another color.` : '';

      ['front', 'back', 'sleeve'].forEach((sd) => {
        const s = S.sides[sd], el = $(`[data-status="${sd}"]`);
        if (s.file) {
          let msg = esc(s.fileName);
          if (!s.previewable) msg += ' · We can\'t preview this file type here, so the shirt shows a placeholder. We\'ll send a proof.';
          else if (s.bgRemoved) msg += ' · Background removed.';
          if (s.upload && s.upload.state === 'uploading') msg += ' · Uploading…';
          if (s.upload && s.upload.state === 'done') msg += ' · Saved ✓';
          if (s.upload && s.upload.state === 'error') msg += ' · Upload failed: ' + esc(s.upload.error);
          el.innerHTML = msg; el.hidden = false;
          el.classList.toggle('is-error', !!(s.upload && s.upload.state === 'error'));
        } else el.hidden = true;
        $(`[data-drop-title="${sd}"]`).textContent = s.file ? 'Replace your art' : 'Drop your art here or choose a file';
      });

      const pr = pricing(), min = P.minQty || 12;
      $('[data-qty-total]').textContent = pr.qty ? `${pr.qty} total` : '';
      $('[data-min-note]').textContent = pr.qty >= min ? '' : `${min} piece minimum (mix any sizes). ${pr.qty ? `Add ${min - pr.qty} more.` : ''}`;
      $('[data-total]').textContent = pr.qty ? money(pr.total) : money(pr.base) + ' each';
      $('[data-each]').textContent = pr.qty
        ? `${money(pr.base * (1 - pr.pct / 100))} each${pr.pct ? ` · ${pr.tier}+ price (${pr.pct}% off)` : ''}`
        : `${layoutName()} · from 12 pieces`;
      const parts = pr.lines.length > 1 ? pr.lines.map((l) => `${l.group}: ${l.qty} × ${money(l.each)}`) : [];
      if (pr.sleeve && pr.qty) parts.push(`Sleeve print: ${pr.qty} × ${money(pr.sleeve.price)}`);
      $('[data-lines]').textContent = parts.length ? parts.join(' · ')
        : (P.groups.length > 1 ? `2XL and up cost a little more (bigger blanks).` : '');
      const nb = pr.next;
      $('[data-next-break]').textContent = nb && pr.qty ? `Order ${nb.qty} or more and save ${nb.pct}% (${money(pr.base * (1 - nb.pct / 100))} each).` : '';
      const ok = pr.qty >= min && pr.lines.every((l) => l.price != null && (!l.variant || l.variant.available));
      $('[data-add]').disabled = !ok;
      $('[data-add]').textContent = pr.qty >= min ? 'Add to cart' : `Add ${Math.max(0, min - pr.qty)} more to order`;
      const bulk = cfg.bulk;
      $('[data-bulk]').innerHTML = bulk ? `Ordering 100+ or need other garments? <a href="${esc(bulk.url)}">Get a bulk quote →</a>` : '';
    }

    function update() { syncUI(); render(); }

    /* --- artwork --- */

    function processArt(s) {
      if (!s.raw) { s.art = null; return; }
      const r = S.removeBg ? removeBackground(s.raw, { holes: S.holes }) : { canvas: s.raw, removed: false };
      s.art = trim(r.canvas);
      s.bgRemoved = r.removed;
    }

    async function upload(file, name) {
      if (!cfg.uploadUrl) return null;
      const r = await fetch(cfg.uploadUrl, { method: 'POST', headers: { 'X-File-Name': encodeURIComponent(name || file.name) }, body: file });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.error || 'upload failed (' + r.status + ')');
      return j.url;
    }

    async function takeFile(sd, file) {
      if (!file) return;
      hideError();
      const ext = (file.name.split('.').pop() || '').toLowerCase();
      if (!cfg.acceptExt.includes(ext)) { showError('That file type isn\'t supported. Use ' + cfg.acceptExt.join(', ').toUpperCase() + '.'); return; }
      if (file.size > (cfg.maxMB || 10) * 1048576) { showError(`Files need to be under ${cfg.maxMB || 10} MB. Email bigger files to us.`); return; }
      const s = S.sides[sd];
      Object.assign(s, { file, fileName: file.name, previewable: PREVIEWABLE.includes(ext) });
      if (S.place[sd]) S.place[sd] = spot0();
      if (sd === 'front' && S.sameArt) S.place.back = spot0();
      if (s.previewable) {
        const url = URL.createObjectURL(file);
        try { s.raw = artToCanvas(await loadImage(url)); } catch (e) { s.raw = null; s.previewable = false; }
        URL.revokeObjectURL(url);
      } else s.raw = null;
      processArt(s);
      S.view = sd === 'sleeve' ? 'front' : sd;   // the sleeve shows on the front view
      s.upload = { state: cfg.uploadUrl ? 'uploading' : 'idle' };
      update();
      if (cfg.uploadUrl) {
        try { const u = await upload(file); if (s.file === file) s.upload = { state: 'done', url: u }; }
        catch (e) { if (s.file === file) s.upload = { state: 'error', error: e.message }; }
        syncUI();
      }
    }

    function showError(t) { const e = $('[data-error]'); e.textContent = t; e.hidden = false; }
    function hideError() { $('[data-error]').hidden = true; }

    /* --- events --- */

    root.addEventListener('click', (ev) => {
      const b = ev.target.closest('button');
      if (!b || !root.contains(b)) return;
      if (b.dataset.color != null) { S.colorIdx = +b.dataset.color; update(); loadPhotos(); }
      else if (b.dataset.spot != null) {
        const [v, id] = b.dataset.spot.split(':');
        if (!id && !S[v === 'front' ? 'back' : 'front']) { showError('Pick at least one print spot.'); return; }
        hideError();
        S[v] = id || null;
        if (id) S.view = v; else if (S.view === v) S.view = v === 'front' ? 'back' : 'front';
        S.place[v] = spot0();
        update();
      } else if (b.dataset.view != null) { S.view = b.dataset.view; update(); }
      else if (b.dataset.sleeve != null) { S.sleeve = b.dataset.sleeve || null; if (S.sleeve) S.view = 'front'; update(); }
      else if (b.dataset.sleeveOpt != null) { S.sleeveOpt = b.dataset.sleeveOpt; update(); }
      else if (b.hasAttribute('data-download')) download();
      else if (b.hasAttribute('data-reset')) {
        S.place[editView()] = spot0(); update();
      } else if (b.hasAttribute('data-add')) addToCart(b);
    });

    const editView = () => (S[S.view] ? S.view : (S.front ? 'front' : 'back'));
    const editing = () => S.place[editView()];
    $('[data-size]').addEventListener('input', (e) => { const v = editView(); editing().wIn = +e.target.value * maxW(v); update(); });
    $('[data-dx]').addEventListener('input', (e) => { editing().dx = +e.target.value; update(); });
    $('[data-dy]').addEventListener('input', (e) => { editing().dy = +e.target.value; update(); });
    $('[data-same]').addEventListener('change', (e) => { S.sameArt = e.target.checked; S.place.back = spot0(); update(); });
    const reprocess = () => ['front', 'back', 'sleeve'].forEach((sd) => processArt(S.sides[sd]));
    $('[data-removebg]').addEventListener('change', (e) => { S.removeBg = e.target.checked; reprocess(); update(); });
    $('[data-holes]').addEventListener('change', (e) => { S.holes = e.target.checked; reprocess(); update(); });
    $('[data-sleeve-same]').addEventListener('change', (e) => { S.sleeveSame = e.target.checked; update(); });
    $('[data-later]').addEventListener('change', (e) => { S.emailLater = e.target.checked; hideError(); });
    root.querySelectorAll('[data-sz]').forEach((inp) => {
      inp.addEventListener('input', () => { S.sizes[inp.dataset.sz] = clamp(parseInt(inp.value, 10) || 0, 0, 999); syncUI(); });
      inp.addEventListener('focus', () => inp.select());
    });
    ['front', 'back', 'sleeve'].forEach((sd) => {
      const input = $(`[data-file="${sd}"]`), drop = $(`[data-drop="${sd}"]`);
      input.addEventListener('change', () => { takeFile(sd, input.files[0]); input.value = ''; });
      ['dragenter', 'dragover'].forEach((t) => drop.addEventListener(t, (e) => { e.preventDefault(); drop.classList.add('is-over'); }));
      ['dragleave', 'drop'].forEach((t) => drop.addEventListener(t, (e) => { e.preventDefault(); drop.classList.remove('is-over'); }));
      drop.addEventListener('drop', (e) => takeFile(sd, e.dataTransfer.files[0]));
    });

    // Drag inside the print box, wheel or pinch to resize. Touches elsewhere scroll the page.
    function toCanvas(ev) {
      const r = canvas.getBoundingClientRect();
      return { x: ((ev.clientX - r.left) / r.width) * canvas.width, y: ((ev.clientY - r.top) / r.height) * canvas.height };
    }
    const onArt = (p) => lastBox && p.x >= lastBox.x - 12 && p.x <= lastBox.x + lastBox.w + 12 && p.y >= lastBox.y - 12 && p.y <= lastBox.y + lastBox.h + 12;
    const pointers = new Map();
    let drag = null, pinch = null;
    canvas.addEventListener('pointerdown', (ev) => {
      if (!S[S.view]) return;
      const p = toCanvas(ev);
      pointers.set(ev.pointerId, p);
      const s = S.place[S.view];
      if (pointers.size === 2) {
        const [a, b] = [...pointers.values()];
        pinch = { d: Math.hypot(a.x - b.x, a.y - b.y), w: artInches(S.view).w }; drag = null; return;
      }
      if (!onArt(p)) return;
      canvas.setPointerCapture(ev.pointerId);
      drag = { px: p.x, py: p.y, dx: s.dx, dy: s.dy };
      canvas.classList.add('is-dragging');
      ev.preventDefault();
    });
    canvas.addEventListener('pointermove', (ev) => {
      const p = toCanvas(ev);
      if (pointers.has(ev.pointerId)) pointers.set(ev.pointerId, p);
      if (!S[S.view]) return;
      const s = S.place[S.view];
      if (pinch && pointers.size === 2) {
        const [a, b] = [...pointers.values()];
        s.wIn = pinch.w * Math.hypot(a.x - b.x, a.y - b.y) / pinch.d;
        update(); return;
      }
      if (drag) {
        s.dx = drag.dx + (p.x - drag.px) / P.ppi;
        s.dy = drag.dy + (p.y - drag.py) / P.ppi;
        update();
      } else canvas.classList.toggle('is-over-patch', !!onArt(p));
    });
    const end = (ev) => { pointers.delete(ev.pointerId); if (pointers.size < 2) pinch = null; drag = null; canvas.classList.remove('is-dragging'); };
    canvas.addEventListener('pointerup', end);
    canvas.addEventListener('pointercancel', end);
    canvas.addEventListener('touchstart', (ev) => {
      if (ev.touches.length > 1 || onArt(toCanvas(ev.touches[0]))) ev.preventDefault();
    }, { passive: false });
    canvas.addEventListener('wheel', (ev) => {
      if (!S[S.view] || !onArt(toCanvas(ev))) return;
      ev.preventDefault();
      const s = S.place[S.view];
      s.wIn = artInches(S.view).w * (ev.deltaY < 0 ? 1.04 : 1 / 1.04);
      update();
    }, { passive: false });

    /* --- export + cart --- */

    function mockupBlob(view) {
      return new Promise((resolve) => {
        const c = makeCanvas(1, 1);
        drawScene(c, view, 1.2, false);
        c.toBlob(resolve, 'image/png');
      });
    }
    const stem = (view) => ('sth-' + P.style + '-' + P.colors[S.colorIdx].name + '-' + view).toLowerCase().replace(/[^a-z0-9]+/g, '-');

    async function download() {
      const blob = await mockupBlob(S.view);
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = stem(S.view) + '-mockup.png';
      document.body.appendChild(a);
      a.click();
      setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
    }

    function properties(mockups) {
      const props = { Color: P.colors[S.colorIdx].name, Print: layoutName() };
      ['front', 'back'].forEach((v) => {
        const sp = spotOf(v); if (!sp) return;
        const s = artSide(v), pl = S.place[v], a = artInches(v), label = v === 'front' ? 'Front' : 'Back';
        props[`${label} art`] = S.emailLater && !s.file ? 'Customer will email art' : (s.upload && s.upload.url) || s.fileName || 'Customer will email art';
        props[`${label} size`] = `${a.w.toFixed(2)} x ${a.h.toFixed(2)} in (${sp.name}, max ${sp.w} x ${sp.h})`;
        if (mockups[v]) props[`${label} mockup`] = mockups[v];
        props[`_${label} offset`] = `${pl.dx.toFixed(2)}, ${pl.dy.toFixed(2)} in from box centre`;
      });
      if (S.sleeve) {
        const o = sleeveOpt();
        props['Sleeve print'] = `${S.sleeve === 'left' ? 'Left' : 'Right'} sleeve, ${o.name.toLowerCase()} up to ${o.w} x ${o.h} in (add-on line)`;
      }
      if (S.removeBg && ['front', 'back', 'sleeve'].some((sd) => S.sides[sd].bgRemoved)) {
        props.Background = S.holes ? 'Remove, including inside letters and shapes' : 'Remove around the art only (inner white prints white)';
      }
      props._Source = 'STH Apparel Builder';
      return props;
    }

    async function addToCart(btn) {
      hideError();
      const used = ['front', 'back'].filter((v) => S[v]).map((v) => artSide(v));
      if (S.sleeve) used.push(sleeveSide());
      if (used.some((s) => !s.file) && !S.emailLater) { showError('Add your art for each print spot, or tick "I\'ll email my art after ordering".'); return; }
      if (used.some((s) => s.upload && s.upload.state === 'uploading')) { showError('Your art is still uploading. One second…'); return; }
      if (used.some((s) => s.upload && s.upload.state === 'error')) { showError('Your art didn\'t upload. Try again, or tick "I\'ll email my art".'); return; }
      const pr = pricing();
      if (pr.qty < (P.minQty || 12)) return;
      btn.disabled = true;
      const label = btn.textContent;
      btn.textContent = 'Adding…';
      try {
        const mockups = {};
        if (cfg.uploadUrl) for (const v of ['front', 'back']) if (S[v] || (v === 'front' && S.sleeve)) mockups[v] = await upload(await mockupBlob(v), stem(v) + '-mockup.png');
        const props = properties(mockups);
        const lines = pr.lines.map((l) => ({
          variantId: l.variant ? l.variant.id : null,
          quantity: l.qty,
          properties: { ...props, Sizes: l.sizes.map((s) => `${s} × ${S.sizes[s]}`).join(', ') },
        }));
        if (pr.sleeve) {
          const sl = sleeveSide();
          lines.push({
            variantId: pr.sleeve.variant ? pr.sleeve.variant.id : null,
            quantity: pr.qty,
            properties: {
              For: `${P.title} · ${P.colors[S.colorIdx].name} · ${layoutName()}`,
              Sleeve: S.sleeve === 'left' ? 'Left sleeve' : 'Right sleeve',
              'Sleeve art': S.sleeveSame && (S.front || S.back) ? 'Same as main print' : (S.emailLater && !sl.file ? 'Customer will email art' : (sl.upload && sl.upload.url) || sl.fileName),
              'Sleeve size': `up to ${pr.sleeve.opt.w} x ${pr.sleeve.opt.h} in`,
              _Source: 'STH Apparel Builder',
            },
          });
        }
        await cfg.onAddToCart({ lines, layout: layoutName(), color: P.colors[S.colorIdx].name, expectedTotal: pr.total });
        btn.textContent = 'Added ✓';
        setTimeout(() => { btn.textContent = label; btn.disabled = false; }, 1600);
      } catch (e) {
        showError('Something went wrong: ' + e.message);
        btn.textContent = label;
        btn.disabled = false;
      }
    }

    update();
    loadPhotos();
    return { state: S, render, properties, mockupBlob, pricing };
  }

  window.STHApparel = { mount };
})();
